@if (layoutState(); as state) {
  <div
    class="button-container-layout"
    [style.flex-direction]="state.direction"
    [style.justify-content]="state.justifyContent"
    [style.align-items]="state.alignItems"
  >
    <ng-template appDynamicContent></ng-template>
  </div>
}
